import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import { RejectWorkOrder, RejectWorkOrderVariables } from '../../athena/types/RejectWorkOrder';

export const REJECT_WORK_ORDER = gql`
  mutation RejectWorkOrder($workOrderID: String, $reason: String) {
    homework {
      rejectWorkOrder(input: { workOrderId: $workOrderID, reason: $reason }) {
        id
        state
      }
    }
  }
`;

const useRejectWorkOrder = () => {
  return useMutation<RejectWorkOrder, RejectWorkOrderVariables>(REJECT_WORK_ORDER);
};

export default useRejectWorkOrder;
